import { ComponentProps } from 'react';
import { useFlag } from '@/features/unleash';
import NotFound from '@/pages/NotFound';
import { NarrativeCommunityProfile } from './NarrativeCommunityProfile';

type ProfileProps = ComponentProps<typeof NarrativeCommunityProfile>;

export const FlaggedNarrativeCommunityProfile = (props: ProfileProps) => {
  const { flagsReady, enabled } = useFlag({
    name: 'mono-hackathon-profile',
  });

  if (flagsReady && enabled) {
    return <NarrativeCommunityProfile {...props} />;
  }

  if (flagsReady && !enabled) {
    return <NotFound />;
  }

  return null;
};
